import React from 'react';
import { motion } from 'framer-motion';
import { Gift, CalendarCheck, LayoutGrid, MessageSquareText } from 'lucide-react';
export function BonusSection() {
  const bonuses = [{
    medal: '🥇',
    icon: <CalendarCheck className="w-6 h-6 text-brand-gold" data-id="element-1" />,
    title: 'Sistema de Seguimiento que Convierte Leads en 30 Días',
    desc: 'Mensajes de WhatsApp listos para copiar y pegar, día por día.'
  }, {
    medal: '🥈',
    icon: <LayoutGrid className="w-6 h-6 text-brand-gold" data-id="element-2" />,
    title: 'Sistema Completo de Gestión Inmobiliaria',
    desc: 'CRM editable, pipeline de ventas y control de visitas.'
  }, {
    medal: '🥉',
    icon: <MessageSquareText className="w-6 h-6 text-brand-gold" data-id="element-3" />,
    title: 'Scripts de WhatsApp que Convierten',
    desc: 'Primer contacto, seguimiento, reactivación y cierre.'
  }];
  return <section className="py-10 px-4 bg-brand-dark text-white relative overflow-hidden" data-id="element-4">
      <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-brand-gold/10 rounded-full blur-[80px] pointer-events-none" data-id="element-5"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-6">
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-6" data-id="element-7">
          <div className="inline-flex items-center gap-2 mb-2" data-id="element-8">
            <Gift className="w-7 h-7 text-brand-gold" data-id="element-9" />
            <h2 className="text-2xl md:text-3xl font-heading font-black" data-id="element-10">
              Bonos Exclusivos
            </h2>
          </div>
          <p className="text-lg text-brand-gold font-bold uppercase tracking-wider" data-id="element-11">
            Gratis por el día de hoy
          </p>
        </motion.div>

        <div className="space-y-3" data-id="element-12">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex items-center gap-3 bg-white/5 border border-white/10 px-4 py-3 rounded-xl" data-id="element-13">
              <span className="text-xl" data-id="element-14">{bonus.medal}</span>
              <div className="bg-white/10 p-1.5 rounded-lg" data-id="element-15">{bonus.icon}</div>
              <div className="flex-1 min-w-0" data-id="element-16">
                <h3 className="text-sm font-bold font-heading leading-tight" data-id="element-17">
                  {bonus.title}
                </h3>
                <p className="text-gray-400 text-xs mt-0.5" data-id="element-18">{bonus.desc}</p>
              </div>
              <span className="flex-shrink-0 text-[10px] font-bold text-brand-green bg-brand-green/20 px-2 py-0.5 rounded-full" data-id="element-19">
                GRATIS
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}